import React, { useState } from 'react';
import PageBanner from '@components/PageBanner';
import TalkToSalesForm from '@features/WhatsNewModal/components/TalkToSalesForm';
import { translate } from '@utils/i18n';
import './TrialBanner.scss';
import { Button } from '@ui';
import AiPlusIcon from '@components/AIBanner/AiPlusIcon';
const namespace = 'trial_banner';
export default function TrialBanner() {
    const [showTalkToSales, setShowTalkToSales] = useState(false);
    const handleTalkToSales = () => {
        setShowTalkToSales(true);
    };
    const handleCloseTalkToSales = () => {
        setShowTalkToSales(false);
    };
    const actionButtons = (React.createElement(Button, { type: "button", onClick: handleTalkToSales }, translate('talk_to_sales', { namespace })));
    return !showTalkToSales ? (React.createElement(PageBanner, { anchorId: "inspections-show", iconPrefix: React.createElement(AiPlusIcon, null), text: React.createElement(React.Fragment, null,
            React.createElement("strong", null, translate('like_what_you_see', { namespace })),
            ' ',
            translate('buy_now_or_reach_out', { namespace })), actionButtons: actionButtons, isSticky: true })) : (React.createElement(TalkToSalesForm, { isOpen: showTalkToSales, onClose: handleCloseTalkToSales }));
}
